<template>
  <a-descriptions :column="1" size="small" bordered class="endpoint-list">
    <a-descriptions-item v-for="item in items" :key="item.label" :label="item.label"
      ><a-typography-text copyable>{{ item.value }}</a-typography-text></a-descriptions-item
    >
  </a-descriptions>
</template>

<script setup lang="ts">
defineProps<{ items: Array<{ label: string; value: string }> }>();
</script>

<style scoped>
.endpoint-list :deep(.ant-typography) {
  overflow-wrap: anywhere;
}
</style>
